export default __webpack_public_path__ + "static/media/Component-3–1.1163f3f3.svg";